import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";

export default function Impressum() {
  return (
    <Dialog>
      <DialogTrigger asChild>
        <button
          data-testid="impressum-button"
          className="link-underline font-mono-accent text-[10px] uppercase tracking-[0.25em] text-white/50 hover:text-[#FBF9F5] pb-1"
          style={{ backgroundImage: "linear-gradient(#FBF9F5,#FBF9F5)" }}
        >
          Impressum
        </button>
      </DialogTrigger>
      <DialogContent
        data-testid="impressum-modal"
        className="max-w-lg bg-[#FBF9F5] text-[#121110] border-none rounded-none p-8 sm:p-10 max-h-[85vh] overflow-y-auto"
      >
        <DialogHeader>
          <DialogTitle className="font-serif-display font-light text-3xl sm:text-4xl tracking-tight text-[#121110]">
            Impressum
          </DialogTitle>
        </DialogHeader>

        <div className="mt-6 space-y-7 font-light text-[#5C5650]">
          <div>
            <p className="font-mono-accent text-[10px] uppercase tracking-[0.25em] text-[#8C857B] mb-2">
              Angaben gemäß § 5 TMG
            </p>
            <p className="text-[#121110]">Süleyman Akkas</p>
            <p>Akkas Music</p>
            <p>Weidenweg 24</p>
            <p>53227 Bonn</p>
            <p>Deutschland</p>
          </div>

          <div>
            <p className="font-mono-accent text-[10px] uppercase tracking-[0.25em] text-[#8C857B] mb-2">
              Kontakt
            </p>
            <p>
              Telefon:{" "}
              <a href="tel:+4917777442473" className="text-[#121110] hover:text-[#C5A880] transition-colors duration-300">
                +49 177 77 424 73
              </a>
            </p>
            <p>
              E-Mail:{" "}
              <a href="mailto:info@akkasmusic.com" className="text-[#121110] hover:text-[#C5A880] transition-colors duration-300">
                info@akkasmusic.com
              </a>
            </p>
          </div>

          <div>
            <p className="font-mono-accent text-[10px] uppercase tracking-[0.25em] text-[#8C857B] mb-2">
              Umsatzsteuer-ID
            </p>
            <p className="leading-relaxed text-sm">
              Umsatzsteuer-Identifikationsnummer gemäß § 27a Umsatzsteuergesetz:
            </p>
            <p className="text-[#121110]">DE314288390</p>
          </div>

          <div>
            <p className="font-mono-accent text-[10px] uppercase tracking-[0.25em] text-[#8C857B] mb-2">
              Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV
            </p>
            <p className="text-[#121110]">Süleyman Akkas</p>
          </div>

          <div>
            <p className="font-mono-accent text-[10px] uppercase tracking-[0.25em] text-[#8C857B] mb-2">
              Haftungsausschluss
            </p>
            <p className="leading-relaxed text-sm">
              Trotz sorgfältiger inhaltlicher Kontrolle übernehmen wir keine Haftung für die Inhalte
              externer Links. Für den Inhalt der verlinkten Seiten sind ausschließlich deren
              Betreiber verantwortlich. Alle Inhalte dieser Website unterliegen dem deutschen
              Urheberrecht.
            </p>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
